import { Observable } from 'rxjs/Rx'
import { Record } from 'immutable'
import { combineEpics } from 'redux-observable'
import { assign } from 'lodash'
import { mergeMap } from 'rxjs/operators'

import { INIT,/* LOADING, SUCCESS, ERROR*/ } from '../../constants/phase'
import { ofType } from 'redux-observable'
import Config from '../../config'

import * as api from './api'

/***********************************
 * Action Types
 ***********/

export const LOGIN = 'cozy/user/LOGIN'
export const LOGIN_SUCCESS = 'cozy/user/LOGIN_SUCCESS'
export const LOGIN_ERROR = 'cozy/user/LOGIN_ERROR'

export const SIGNIN = 'cozy/user/SIGNIN'
export const SIGNIN_SUCCESS = 'cozy/user/SIGNIN_SUCCESS'
export const SIGNIN_ERROR = 'cozy/user/SIGNIN_ERROR'

export const FETCH_USER = 'cozy/user/FETCH_USER'
export const FETCH_USER_SUCCESS = 'cozy/user/FETCH_USER_SUCCESS'
export const FETCH_USER_ERROR = 'cozy/user/FETCH_USER_ERROR'

export const DELETE_ACCOUNT = 'cozy/user/DELETE_ACCOUNT'
export const DELETE_ACCOUNT_SUCCESS = 'cozy/user/DELETE_ACCOUNT_SUCCESS'
export const DELETE_ACCOUNT_ERROR = 'cozy/user/DELETE_ACCOUNT_ERROR'

export const FORGOT_PASSWORD = 'cozy/user/FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SUCCESS = 'cozy/user/FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'cozy/user/FORGOT_PASSWORD_ERROR'

export const RESET_PASSWORD = 'cozy/user/RESET_PASSWORD'
export const RESET_PASSWORD_SUCCESS = 'cozy/user/RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'cozy/user/RESET_PASSWORD_ERROR'

export const SIGN_OUT = 'cozy/user/SIGN_OUT'
export const RESER_USER_PROPS = 'cozy/user/RESER_USER_PROPS'


/***********************************
 * Initial State
 ***********/

// Unlike other ducks we are taking a class style approach
// for creating the InitialState. This is becuase we need to fetch the
// locally stored token in the constructor when it is created
const InitialStateInterface = {
  token: null,  // We need this here to tell InitialState that there is a token key,
                // but it will be reset below to what is in localStorage, unless a value
                // is passed in when the object is instanciated
  loginSuccess: null,
  signinSuccess: null,
  phase: INIT,
  forgotPassword: null,
  resetPassword: null,
  deleteAccount: null
}
class InitialState extends Record(InitialStateInterface) {
  constructor(desiredValues) {
    // When we construct InitialState, we automatically update it's default value
    // for token to be what is stored in localStorage
    const token = localStorage.getItem(Config.LocalStorageKeys.Authorization)
    super(assign({ token }, desiredValues))
  }
}

/***********************************
 * Reducer
 ***********/

// eslint-disable-next-line complexity, max-statements
export default function (state = new InitialState(), action = {}) {

  switch (action.type) {
    case LOGIN_SUCCESS: {
      const { payload } = action
      return state
        .set('loginSuccess', payload)
    }
    case SIGNIN_SUCCESS: {
      const { payload } = action
      return state
        .set('signinSuccess', payload)
    }
    case DELETE_ACCOUNT_SUCCESS: {
      const { payload } = action
      return state
        .set('deleteAccount', payload)
    }
    case SIGN_OUT: {
      localStorage.clear()
      return new InitialState()
    }
    case FORGOT_PASSWORD_SUCCESS: {
      const { payload } = action
      return state
        .set('forgotPassword', payload.data)
    }
    case RESET_PASSWORD_SUCCESS: {
      const { payload } = action
      return state
        .set('resetPassword', payload)
    }
    case RESER_USER_PROPS: {
      return state
        .set('forgotPassword', null)
    }
    default: {
      return state
    }
  }

}


/***********************************
 * Action Creators
 ***********/

export const login = (payload) => {
  return {
    type: LOGIN,
    payload
  }
}

export const forgotPassword = (payload) => {
  return {
    type: FORGOT_PASSWORD,
    payload
  }
}

export const resetPassword = (payload) => {
  return {
    type: RESET_PASSWORD,
    payload
  }
}

export const signIn = (payload) => {
  return {
    type: SIGNIN,
    payload
  }
}

export const deleteAccount = (payload) => {
  return {
    type: DELETE_ACCOUNT,
    payload
  }
}

export const signOut = (payload) => {
  return {
    type: SIGN_OUT
  }
}

export const resetUserProps = () => {
  return {
    type: RESER_USER_PROPS
  }
}

/***********************************
 * Epics
 ***********************************/

const loginEpic = action$ =>
  action$.pipe(
    ofType(LOGIN),
    mergeMap(action => {
      return Observable.from(api.login(action.payload))
      .flatMap(payload => [{
        type: LOGIN_SUCCESS,
        payload
      }, {
        type: FETCH_USER,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: LOGIN_ERROR,
          payload: { error }
        })
      )
    })
  )

const signInEpic = action$ =>
  action$.pipe(
    ofType(SIGNIN),
    mergeMap(action => {
      return Observable.from(api.signIn(action.payload))
      .flatMap(payload => [{
        type: SIGNIN_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: SIGNIN_ERROR,
          payload: { error }
        })
      )
    })
  )

const fetchUserEpic = action$ =>
  action$.pipe(
    ofType(FETCH_USER),
    mergeMap(action => {
      return Observable.from(api.fetchUser(action.payload))
      .flatMap(payload => [{
        type: FETCH_USER_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: FETCH_USER_ERROR,
          payload: { error }
        })
      )
    })
  )

const deleteAccountEpic = action$ =>
  action$.pipe(
    ofType(DELETE_ACCOUNT),
    mergeMap(action => {
      return Observable.from(api.deleteAccount(action.payload))
      .flatMap(payload => [{
        type: DELETE_ACCOUNT_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: DELETE_ACCOUNT_ERROR,
          payload: { error }
        })
      )
    })
  )

const forgotPasswordEpic = action$ =>
  action$.pipe(
    ofType(FORGOT_PASSWORD),
    mergeMap(action => {
      return Observable.from(api.forgotPassword(action.payload))
      .flatMap(payload => [{
        type: FORGOT_PASSWORD_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: FORGOT_PASSWORD_ERROR,
          payload: { error }
        })
      )
    })
  )

const resetPasswordEpic = action$ =>
  action$.pipe(
    ofType(RESET_PASSWORD),
    mergeMap(action => {
      return Observable.from(api.resetPassword(action.payload))
      .flatMap(payload => [{
        type: RESET_PASSWORD_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: RESET_PASSWORD_ERROR,
          payload: { error }
        })
      )
    })
  )

export const userEpic = combineEpics(
  loginEpic,
  signInEpic,
  fetchUserEpic,
  deleteAccountEpic,
  forgotPasswordEpic,
  resetPasswordEpic
)



// WEBPACK FOOTER //
// ./src/store/user/duck.js